import React, { useEffect, useState } from 'react';
import { IntlProvider, IntlShape, RawIntlProvider, useIntl } from 'react-intl';

import { flattenMessages, getMessages } from '.';

export const EloIntlProvider: React.FC = ({ children }) => {
  const [messages, setMessages] = useState(undefined);

  useEffect(() => {
    getMessages('pt').then(messages => {
      setMessages(messages);
    });
  }, []);

  return (
    <IntlProvider locale="pt" messages={flattenMessages(messages)}>
      <EloIntlProviderOverride>{children}</EloIntlProviderOverride>
    </IntlProvider>
  );
};

const EloIntlProviderOverride: React.FC = ({ children }) => {
  const originalIntl = useIntl();
  const customIntl: IntlShape = { ...originalIntl };

  customIntl.formatNumber = (value, opts = {}) =>
    originalIntl.formatNumber(value, {
      roundingMode: 'halfEven',
      ...opts
    });

  return <RawIntlProvider value={customIntl}>{children}</RawIntlProvider>;
};
